
import React from "react";
import { ReactComponent as HdfcLogo } from "assets/img/svg/hdfcLogo.svg";

const BANK_LOGO_MAP = {
    HDFC: HdfcLogo
};


export const getHeaderChipInfo = ({ label, value, chipType, styles }) => {
    if (!value) return {};

    switch (chipType) {
        case "TYPE":
            return {
                // text: `${label}: ${value}`,
                bgColor: "#F5F5F5",
                textColor: "#262626",
                children: (
                    <>
                        <span className={styles['chipLabel']}>{label}:</span>
                        <span className={styles['chipValue']}>{value}</span>
                    </>
                )
            };

        case "BANK": {
            const Logo = BANK_LOGO_MAP[value];
            return {
                bgColor: "#F5F5F5",
                textColor: "#262626",
                children: (
                    <>
                        {Logo && <Logo width={16} height={16} className={styles['bankLogo']} />}
                        <span className={styles['chipLabel']}>{label}:</span>
                        <span className={styles['chipValue']}>{value}</span>
                    </>
                )
            };
        }
        default:
            return {};
    }
};


export const FILTER__FORM_FIELDS_GLOBAL = {
    searchByValue: "",
    searchBy: "",
};

export const SEARCH_BY = [
    {
        key: "psid",
        value: "By PSID",
    },
];

export const HEADER_CHIPS_CONFIG = [
    {
        key: "type",
        label: "Type",
        chipType: "TYPE"
    },
    {
        key: "bankName",
        label: "Bank name",
        chipType: "BANK"
    },
    {
        key: "accountNo",
        label: "Account no.",
        chipType: "TYPE"
    }
];
export const getProgressStepList = (approvalLevelCount = 0,onEditReceipt) => {
    const initialSteps = [{ title: "Request Created" },
    { title: "Sent for approval" },];
    const approvalSteps = Array.from({ length: approvalLevelCount }, (_, i) => ({ title: `L${i + 1} Approval`,actionNeededText:'Edit', onEdit: onEditReceipt }));
    const finalStep = { title: 'Deposited' };

    return [...initialSteps, ...approvalSteps, finalStep];
};
